import React from 'react';
import { Stars, Sparkles } from '@react-three/drei';

export default function Starfield() {
  return (
    <>
      <Stars radius={200} depth={80} count={4000} factor={4} saturation={0} fade speed={0.5} />
      <Sparkles count={100} scale={[50, 50, 50]} size={2} speed={0.3} opacity={0.5} color="#43DDD0" />
      <Sparkles count={150} scale={[70, 70, 70]} size={1.5} speed={0.2} opacity={0.3} color="#ffffff" />
    </>
  );
}
